import { render, staticRenderFns } from "./InputRadioButtons.vue?vue&type=template&id=62499743"
import script from "./InputRadioButtons.vue?vue&type=script&lang=js"
export * from "./InputRadioButtons.vue?vue&type=script&lang=js"
import style0 from "./InputRadioButtons.vue?vue&type=style&index=0&id=62499743&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports